import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { TabsContent } from '../../../components/ui/tabs';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../../components/ui/table';
import { ScrollArea } from '../../../components/ui/scroll-area';
import { Skeleton } from '../../../components/ui/skeleton';
import { Users, Phone, Mail, Plus, Edit, Trash2 } from 'lucide-react';

export const BiginContactsTab = ({ contacts, deleteContact, formatDate, loading, openCreateContact, openEditContact }) => (
        <TabsContent value="contacts" className="mt-4">
          <Card className="bg-white border shadow-sm">
            <CardHeader>
              <div className="flex items-center justify-between">
                <div>
                  <CardTitle className="text-lg">Contacts</CardTitle>
                  <CardDescription>{contacts.length} contacts synced</CardDescription>
                </div>
                <Button onClick={openCreateContact} className="bg-teal-600 hover:bg-teal-700">
                  <Plus className="w-4 h-4 mr-2" /> Add Contact
                </Button>
              </div>
            </CardHeader>
            <CardContent>
              {loading ? (
                <div className="space-y-3">
                  {[1, 2, 3].map(i => <Skeleton key={i} className="h-16 w-full" />)}
                </div>
              ) : contacts.length === 0 ? (
                <div className="text-center py-8 text-gray-500">
                  <Users className="w-12 h-12 mx-auto mb-3 text-gray-300" />
                  <p>No contacts found. Click "Sync Now" to fetch data from Bigin or "Add Contact" to create one.</p>
                </div>
              ) : (
                <ScrollArea className="h-[400px]">
                  <Table>
                    <TableHeader>
                      <TableRow>
                        <TableHead>Name</TableHead>
                        <TableHead>Email</TableHead>
                        <TableHead>Phone</TableHead>
                        <TableHead>Company</TableHead>
                        <TableHead>Created</TableHead>
                        <TableHead className="w-24">Actions</TableHead>
                      </TableRow>
                    </TableHeader>
                    <TableBody>
                      {contacts.map((contact) => (
                        <TableRow key={contact.bigin_id || contact.id} data-testid="contact-row">
                          <TableCell className="font-medium">
                            {contact.Full_Name || `${contact.First_Name || ''} ${contact.Last_Name || ''}`.trim() || 'Unknown'}
                          </TableCell>
                          <TableCell>
                            {contact.Email ? (
                              <a href={`mailto:${contact.Email}`} className="text-[hsl(187,70%,38%)] hover:underline flex items-center gap-1">
                                <Mail className="w-3 h-3" />
                                {contact.Email}
                              </a>
                            ) : 'N/A'}
                          </TableCell>
                          <TableCell>
                            {contact.Phone ? (
                              <span className="flex items-center gap-1 text-gray-600">
                                <Phone className="w-3 h-3" />
                                {contact.Phone}
                              </span>
                            ) : 'N/A'}
                          </TableCell>
                          <TableCell>{contact.Account_Name?.name || 'N/A'}</TableCell>
                          <TableCell>{formatDate(contact.Created_Time)}</TableCell>
                          <TableCell>
                            <div className="flex items-center gap-1">
                              <Button variant="ghost" size="sm" onClick={() => openEditContact(contact)} className="h-8 w-8 p-0">
                                <Edit className="w-4 h-4 text-gray-500" />
                              </Button>
                              <Button variant="ghost" size="sm" onClick={() => deleteContact(contact.id || contact.bigin_id)} className="h-8 w-8 p-0 text-red-500 hover:text-red-700">
                                <Trash2 className="w-4 h-4" />
                              </Button>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </ScrollArea>
              )}
            </CardContent>
          </Card>
        </TabsContent>
);
